<template>
  <div>
    <!-- Header card skeleton -->
    <div class="bg-white border border-black/6 rounded-[20px] p-6 mb-7 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
      <div class="flex items-start justify-between gap-5">
        <div class="flex items-start gap-5">
          <skeleton width="64px" height="64px" rounded="50%"></skeleton>
          <div class="flex flex-col gap-2 pt-1">
            <skeleton width="180px" height="24px"></skeleton>
            <skeleton width="120px" height="14px"></skeleton>
            <skeleton width="200px" height="14px"></skeleton>
          </div>
        </div>
        <div class="flex gap-2">
          <skeleton width="72px" height="32px" rounded="9999px"></skeleton>
          <skeleton width="90px" height="32px" rounded="9999px"></skeleton>
        </div>
      </div>
      <div class="mt-5 pt-5 border-t border-black/6">
        <div class="flex items-center justify-between mb-2.5">
          <skeleton width="120px" height="13px"></skeleton>
          <skeleton width="32px" height="13px"></skeleton>
        </div>
        <skeleton width="100%" height="6px" rounded="3px"></skeleton>
      </div>
    </div>

    <!-- Two-column grid skeleton -->
    <div class="applicant-body grid items-start">
      <!-- Left: requirement sections -->
      <div class="min-w-0">
        <div v-for="i in 3" :key="i" class="mb-6">
          <div class="flex items-center gap-2.5 mb-3 px-1.5">
            <skeleton width="130px" height="12px"></skeleton>
            <skeleton width="28px" height="18px" rounded="50px"></skeleton>
          </div>
          <div class="flex flex-col gap-2">
            <div v-for="j in (i === 1 ? 3 : 2)" :key="j" class="bg-white border border-black/6 rounded-[20px] px-[18px] py-3.5 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">
              <div class="flex items-start gap-4">
                <div class="flex-1 flex flex-col gap-2">
                  <skeleton width="60%" height="14px"></skeleton>
                  <skeleton width="40%" height="13px"></skeleton>
                </div>
                <div class="flex items-center gap-3 shrink-0">
                  <skeleton width="70px" height="13px"></skeleton>
                  <skeleton width="22px" height="22px" rounded="50%"></skeleton>
                  <skeleton width="60px" height="24px" rounded="9999px"></skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right: sidebar -->
      <div class="applicant-sidebar pl-7">
        <div v-for="i in 3" :key="'s'+i" class="bg-white border border-black/6 rounded-[20px] p-6 shadow-[0_2px_12px_rgba(0,0,0,0.04)] mb-6">
          <div class="flex items-center gap-2 mb-5">
            <skeleton width="80px" height="12px"></skeleton>
            <skeleton width="22px" height="18px" rounded="50px"></skeleton>
          </div>
          <div class="flex flex-col gap-3">
            <div v-for="j in 3" :key="j" class="flex items-center gap-2.5">
              <skeleton width="30px" height="30px" rounded="50%"></skeleton>
              <div class="flex-1 flex flex-col gap-1">
                <skeleton width="100%" height="14px"></skeleton>
                <skeleton width="60px" height="11px"></skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonApplicant',
  components: { Skeleton }
}
</script>

<style scoped>
.applicant-body {
  grid-template-columns: 1fr 340px;
}

@media (max-width: 1200px) {
  .applicant-body {
    grid-template-columns: 1fr;
  }

  .applicant-sidebar {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    padding-top: 28px;
    margin-top: 4px;
  }
}

@media (max-width: 768px) {
  .applicant-body {
    grid-template-columns: 1fr;
  }
}
</style>
